const sanityClient = require("@sanity/client");

const client = sanityClient({
  projectId: "ultyvon6",
  dataset: "production",
  useCdn: true,
});

export default client;
